import { render, staticRenderFns } from "./PopularFilterBar.vue?vue&type=template&id=ac3b8ec6&scoped=true"
import script from "./PopularFilterBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopularFilterBar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PopularFilterBar.vue?vue&type=style&index=0&id=ac3b8ec6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3b8ec6",
  null
  
)

export default component.exports